import { axiosInstance } from '.'
import { InvestmentSearchParams, InvestorInvestmentSearchParams } from '../lib/types'
import { removeEmptyValueFromObject } from '../lib/utils/helpers'
import {
  SEARCH_INVESTMENTS_V1,
  GET_INVESTMENT_DETAIL_FOR_INVESTOR_V1,
  GET_INVESTMENT_BY_ID,
  UPDATE_INVESTMENT_STATUS_V1,
  UPDATE_TRADE_EXECUTED_INVESTMENT_V1,
  GET_INVESTMENT_AUDIT_LOG_V1,
  SET_INVESTMENT_LIMIT_V1,
  UPLOAD_ALLOTMENT_CONFIRMATION,
} from './endpoints'

export const investmentServices = {
  getInvestments: async (params: InvestmentSearchParams | InvestorInvestmentSearchParams) => {
    try {
      const data = await axiosInstance.get(SEARCH_INVESTMENTS_V1, {
        params: removeEmptyValueFromObject(params),
      })
      return {
        investments: data.data.investments,
        pagination: {
          count: data.data.count,
          limit: data.data.limit,
          offset: data.data.offset,
          total: data.data.total,
        },
        status: data.status,
      }
    } catch (error: any) {
      return error.response
    }
  },
  getInvestmentDetailForInvestor: async (investorId: string) => {
    try {
      const data = await axiosInstance.get(
        GET_INVESTMENT_DETAIL_FOR_INVESTOR_V1(Number(investorId)),
      )
      return data
    } catch (error: any) {
      return error.response
    }
  },

  // v1
  getInvestmentById: async (id: string) => {
    try {
      const data = await axiosInstance.get(`${GET_INVESTMENT_BY_ID}/${id}`)
      const opportunity = {
        ...data.data,
      }

      return { data: opportunity, status: data.status }
    } catch (error: any) {
      return error.response
    }
  },
  uploadAllotmentConfirmation: async (file: File) => {
    try {
      const formData = new FormData()
      formData.append('file', file)
      return await axiosInstance.post(UPLOAD_ALLOTMENT_CONFIRMATION, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    } catch (error: any) {
      return error.response
    }
  },
  updateInvestmentStatus: async (payload: any) => {
    try {
      const updatePayload = {
        id: Number(payload.investmentId),
        status: payload.status ?? payload.investmentStatus,
        description: payload.description,
        units: payload.units,
        tradeExecutionDate: payload.tradeExecutionDate,
        refundDate: payload.refundDate,
        refundAmount: payload.refundAmount,
        actualInvestedAmount: payload.actualInvestedAmount,
        allotmentConfirmation: payload.allotmentConfirmation,
        rateOfConversion: payload.rateOfConversion,
        skipEmail: payload.skipEmail,
      }
      const data = await axiosInstance.patch(
        UPDATE_INVESTMENT_STATUS_V1,
        removeEmptyValueFromObject(updatePayload),
      )
      return data
    } catch (error: any) {
      return error.response
    }
  },
  updateTradeExecutedInvestmentDetails: async (payload: {
    id: number
    tradeExecutionDate?: string
    amountCents?: number
    units?: number
    tradeReferenceDetails?: string
    allotmentConfirmation?: string
    skipEmail?: boolean
  }) => {
    try {
      const body: Record<string, unknown> = { id: payload.id }
      if (payload.tradeExecutionDate !== undefined) {
        body.tradeExecutionDate = payload.tradeExecutionDate
      }
      if (payload.amountCents !== undefined) {
        body.actualInvestedAmount = payload.amountCents
      }
      if (payload.units !== undefined) {
        body.units = payload.units
      }
      if (payload.tradeReferenceDetails !== undefined) {
        body.tradeReferenceDetails = payload.tradeReferenceDetails
      }
      if (payload.allotmentConfirmation !== undefined) {
        body.allotmentConfirmation = payload.allotmentConfirmation
      }
      if (payload.skipEmail !== undefined) {
        body.skipEmail = payload.skipEmail
      }
      const data = await axiosInstance.patch(UPDATE_TRADE_EXECUTED_INVESTMENT_V1, body)
      return data
    } catch (error: any) {
      return error.response
    }
  },
  getInvestmentAuditLog: async (investmentId: string) => {
    try {
      const data = await axiosInstance.get(GET_INVESTMENT_AUDIT_LOG_V1(Number(investmentId)))
      return data
    } catch (error: any) {
      return error.response
    }
  },
  setInvestmentLimit: async (investorId: number, investmentLimit: number) => {
    try {
      const payload = {
        investorId,
        investmentLimit,
      }
      const data: any = await axiosInstance.patch(SET_INVESTMENT_LIMIT_V1, payload)
      return { ...data }
    } catch (error: any) {
      return error.response
    }
  },
}
